import type { ReactNode } from 'react';

export type TouchTargetProps = {
  children: ReactNode;
};

export const TouchTarget = ({ children }: TouchTargetProps) => {
  return (
    <>
      <span
        data-slot="touch-target"
        className="absolute top-1/2 left-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden"
        aria-hidden="true"
      />
      {children}
    </>
  );
};
